/**
 * Tools 配置 - 整合入口
 * 
 * 为了向后兼容，此文件整合所有子模块的 Tools 配置
 * 使用方式不变: $t('tools.xxx')
 */

import common from './tools/common'
import videoTools from './tools/video-tools'
import imageTools from './tools/image-tools'
import messages from './tools/messages'

// 支持的语言列表
const languages = ["zh","en","ja","ko","tw","pl","es","fr","de","ru","pt","it","ar","th","da","no","nl","id","tr"] as const

type LangKey = typeof languages[number]

// 合并所有子模块
const merged: Record<LangKey, Record<string, any>> = {} as any

for (const lang of languages) {
    merged[lang] = {
        ...(common as any)[lang],
        ...(videoTools as any)[lang],
        ...(imageTools as any)[lang],
        ...(messages as any)[lang],
    }
}

export default merged
